import { memo } from "react"
import { Link } from "react-router-dom";
import "./style.scss";
import React, { useState} from 'react';
import QuickLinkModal from "component/QuickLinkModal";
const Footer = () => {
    const [selectedLink, setSelectedLink] = useState(null);

    const handleLinkClick = (key) => {
        setSelectedLink(key);
    };
    return <footer className="footer">
        <div className="container">
            <div className="row">
                <div className="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                    <div className="footer__about">
                        <h1 className="footer__about__logo">EchoVault</h1>
                        <ul>
                            <li>Address: 1 Dai Co Viet</li>
                            <li>Phone: 0948440803</li>
                            <li>Email: echovaultsupport@gmail.com</li>
                        </ul>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                    <div className="footer__widget">
                        <h6>Quick Links</h6>
                        <ul>
                            <li><a href="#" onClick={(e) => { e.preventDefault(); handleLinkClick("contact"); }}>Contact</a></li>
                            <li><a href="#" onClick={(e) => { e.preventDefault(); handleLinkClick("about"); }}>About Us</a></li>
                            <li><a href="#" onClick={(e) => { e.preventDefault(); handleLinkClick("features"); }}>Features</a></li>
                        </ul>
                        <ul>
                            <li><a href="#" onClick={(e) => { e.preventDefault(); handleLinkClick("privacy"); }}>Privacy Policy</a></li>
                            <li><a href="#" onClick={(e) => { e.preventDefault(); handleLinkClick("terms"); }}>Terms of Service</a></li>
                            <li><a href="#" onClick={(e) => { e.preventDefault(); handleLinkClick("faq"); }}>FAQs</a></li>
                        </ul>
                    </div>
                </div>
                <div className="col-lg-3 col-md-12 col-sm-12 col-xs-12">
                    <div className="footer__widget">
                        <h6>Newsletter</h6>
                        <p> Subscribe to get the latest updates</p>
                        <form action="#">
                            <div className="input-group">
                                <input type="text" placeholder="Type your email here" />
                                <button type="submit" className="button-submit">
                                    Regist
                                </button>
                            </div>
                            <div className="footer__widget__social">
                                <div>
                                    <Link to="https://facebook.com">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 50 50">
                                            <path d="M40,0H10C4.486,0,0,4.486,0,10v30c0,5.514,4.486,10,10,10h30c5.514,0,10-4.486,10-10V10C50,4.486,45.514,0,40,0z M39,17h-3 c-2.145,0-3,0.504-3,2v3h6l-1,6h-5v20h-7V28h-3v-6h3v-3c0-4.677,1.581-8,7-8c2.902,0,6,1,6,1V17z">
                                            </path>
                                        </svg>
                                    </Link>
                                </div>
                                <div>
                                    <Link to="https://instagram.com">
                                        <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 169.063 169.063">
                                            <g>
                                                <path d="M122.406,0H46.654C20.929,0,0,20.93,0,46.655v75.752c0,25.726,20.929,46.655,46.654,46.655h75.752c25.727,0,46.656-20.93,46.656-46.655V46.655C169.063,20.93,148.133,0,122.406,0z M154.063,122.407c0,17.455-14.201,31.655-31.656,31.655H46.654C29.2,154.063,15,139.862,15,122.407V46.655C15,29.201,29.2,15,46.654,15h75.752c17.455,0,31.656,14.201,31.656,31.655V122.407z" />
                                                <path d="M84.531,40.97c-24.021,0-43.563,19.542-43.563,43.563c0,24.02,19.542,43.561,43.563,43.561s43.563-19.541,43.563-43.561C128.094,60.512,108.552,40.97,84.531,40.97z M84.531,113.093c-15.749,0-28.563-12.812-28.563-28.561c0-15.75,12.813-28.563,28.563-28.563s28.563,12.813,28.563,28.563C113.094,100.281,100.28,113.093,84.531,113.093z" />
                                                <path d="M129.921,28.251c-2.89,0-5.729,1.17-7.77,3.22c-2.051,2.04-3.23,4.88-3.23,7.78c0,2.891,1.18,5.73,3.23,7.78c2.04,2.04,4.88,3.22,7.77,3.22c2.9,0,5.73-1.18,7.78-3.22c2.05-2.05,3.22-4.89,3.22-7.78c0-2.9-1.17-5.74-3.22-7.78C135.661,29.421,132.821,28.251,129.921,28.251z" />
                                            </g>
                                        </svg>
                                    </Link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="row copyright">
                <div className="col-12 text-center">
                    <p>© 2025 EchoVault. All rights reserved.</p>
                </div>
            </div>
        </div>
        <QuickLinkModal sectionKey={selectedLink} onClose={() => setSelectedLink(null)} />
    </footer>;
};

export default memo(Footer);